const sortByArray = (arr, order) => [...order.filter(i => arr.includes(i)), ...arr.filter(i => !order.includes(i))];

const encodeURIPart = str => encodeURIComponent(encodeURIComponent(str));

const decodeURIPart = str => {
  try {
    return decodeURIComponent(decodeURIComponent(str));
  } catch {
    try {
      return decodeURIComponent(str);
    } catch {
      return str;
    }
  }
};

const parseParams = (str, separator) => {
  const rows = str.split(separator);
  return rows.reduce((acc, row) => {
    if (!row.length) return acc;
    const p = row.split('=');
    const key = decodeURIPart(p[0]);
    const value = p[1] || p[1] === '' ? decodeURIPart(p[1]) : true;
    return { ...acc, [key]: value };
  }, {});
};

const stringifyParams = (params = {}, separator) => {
  const keys = Object.keys(params);
  const rows = keys.reduce((acc, key) => {
    const value = params[key];
    return value === true
      ? [...acc, encodeURIPart(key)]
      : value || value === ''
      ? [...acc, `${encodeURIPart(key)}=${encodeURIPart(value)}`]
      : acc;
  }, []);
  return rows.join(separator);
};

const parse = ({ pathname, search, hash }) => {
  const matrixGroups = pathname.split('/');
  const matrix = matrixGroups.reduce((acc, part) => {
    const [, group, value] = /^([^;]*);?(.*)$/.exec(part);
    return !group || !value
      ? acc
      : {
          ...acc,
          [group]: parseParams(value, ';'),
        };
  });
  const result = { matrix };

  const [, view, query] = /^\??(?:([^&=]*)&)?(.*)$/.exec(search + '&');
  view && (result.view = view);
  hash && (result.hash = hash);
  query && (result.query = parseParams(query, '&'));

  return result;
};

const stringify = ({ matrix = {}, view, query = {}, hash = '' }, order = []) => {
  const matrixKeys = order.length > 0 ? sortByArray(Object.keys(matrix), order) : Object.keys(matrix);
  const matrixStr = matrixKeys.reduce((acc, key) => {
    const params = matrix[key] || {};
    const paramsStr = stringifyParams(params, ';');
    return paramsStr ? `${acc}/${key};${paramsStr}` : acc;
  }, '');
  const viewStr = view ? `view?${view}` : '?';
  const queryStr = stringifyParams(query, '&');
  return queryStr ? `${matrixStr}/${viewStr}&${queryStr}${hash}` : `${matrixStr}/${viewStr}${hash}`;
};

export default {
  parse,
  stringify,
};
